import { type FC, memo, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Image from '../../../../../../../../shared/components/Image';
import TermsInfoModal from './TermsInfoModal';
import styles from './TermsInfoModal.module.css';

interface ITermsModalData {
  isOpen: boolean;
  title: string;
  content: string;
  campaignId: string;
  campaignName: string;
}

interface CampaignTermsInfoProps {
  campaignId: string;
  campaignName: string;
  terms?: string;
}

const CampaignTermsInfo: FC<CampaignTermsInfoProps> = ({ campaignId, campaignName, terms }) => {
  const [modalData, setModalData] = useState<ITermsModalData>();
  const { t } = useTranslation();

  const handleTermsClick = useCallback(() => {
    setModalData({
      isOpen: true,
      title: t('tournaments.terms_and_conditions', 'Terms & Conditions'),
      content: terms || '',
      campaignId,
      campaignName,
    });
  }, [campaignId, campaignName, terms, t]);

  return (
    <>
      {modalData?.isOpen && <TermsInfoModal modalData={modalData} setModalData={setModalData} />}
      <Image
        onClick={handleTermsClick}
        src="/tournaments/icons/Info"
        manualAffix=".svg"
        alt="Campaign Terms and Conditions"
        className={styles.infoIcon}
      />
    </>
  );
};

export default memo(CampaignTermsInfo);
